import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.86225 4.86192C5.1226 4.60157 5.54471 4.60157 5.80506 4.86192L8.00033 7.05718L10.1956 4.86192C10.4559 4.60157 10.878 4.60157 11.1384 4.86192C11.3987 5.12227 11.3987 5.54438 11.1384 5.80473L8.94313 7.99999L11.1384 10.1953C11.3987 10.4556 11.3987 10.8777 11.1384 11.1381C10.878 11.3984 10.4559 11.3984 10.1956 11.1381L8.00033 8.9428L5.80506 11.1381C5.54471 11.3984 5.1226 11.3984 4.86225 11.1381C4.6019 10.8777 4.6019 10.4556 4.86225 10.1953L7.05752 7.99999L4.86225 5.80473C4.6019 5.54438 4.6019 5.12227 4.86225 4.86192Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }